import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { ProductCategoryDropdownComponent } from "@shared/components/product-category-dropdown/product-category-dropdown.component";
import { SharedModule } from "@shared/shared.module";
import { CustomHeaderService } from "app/layout/common/custom-header-title.service";
import { HasAnyAuthorityDirective } from "app/mock-api/common/auth/has-any-authority.directive";

@Component({
  selector: "app-custom-header",
  imports: [SharedModule, ProductCategoryDropdownComponent, HasAnyAuthorityDirective],
  standalone: true,
  templateUrl: "./custom-header.component.html",
  styleUrl: "./custom-header.component.scss",
})
export class CustomHeaderComponent {
  customerHeaderService = inject(CustomHeaderService);

  constructor() { } // private router: Router

  private router = inject(Router);

  navigate() {
    this.customerHeaderService.clearEntityContext();
    const link = this.customerHeaderService.newEntityRouterLink();
    this.router.navigateByUrl(link);
  }
}
